
// country.js 파일 안의 value 값이랑 매칭되는지 확인 후 매칭되면 label 값을 가져옴
import country from "../../src/services/config/country";

const getCountryName = (value: string) => {
    const countryName = country.find((item) => item.value === value);
    return countryName?.label;
};

export default getCountryName;